import Vue from 'vue'
import Router from 'vue-router'
import index from '@/page/index'

Vue.use(Router)

const router = new Router({
	linkActiveClass: 'on',
	routes: [{
		path: '/',
		component: index,
		meta:{
			title: '天上白玉京v1.0'
		}
	}]
})

router.beforeEach((to, from, next) => {
	setTitle(to.meta.title);
	next()
});

export default router;

function setTitle(title){
	document.title = title;
}


// WEBPACK FOOTER //
// ./src/router/index.js